// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SortLabel--moderator":"fo_a bhh_hq","SortLabel__newFeature":"fo_b bhh_vh bhh_vv"};